import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [LoginComponent, NotFoundComponent],
  imports: [
    CommonModule,
    FormsModule,
    ShowHidePasswordModule,
    SharedModule
  ],
  exports: [LoginComponent]
})
export class AuthModule { }
